import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Box, Typography, Link as MUILink } from '@mui/material';
import { useTheme } from '@mui/system';
import config from '@configFile';

const BlogPostAuthorBio = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const color = isDarkMode ? '#BDA4F4' : 'primary.main';
  return (
    <Box paddingBottom="24px">
      <Box
        component="aside"
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
          textAlign: { xs: 'center', sm: 'left' },
          gap: 2,
          padding: 3,
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: 'background.paper',
          margin: '0 auto'
        }}
      >
        {/* Author Image */}
        <Avatar
          src="https://jungledealsblog.com/jd-images/blog/2025-02-22/author-sarah.jpg"
          alt="Photo of Sarah Elizabeth"
          sx={{
            width: 80,
            height: 80,
            marginBottom: { xs: 1, sm: 0 } // Adds margin when stacked
          }}
        />

        {/* Author Details */}
        <Box>
          <Typography variant="h6" component="h2" fontWeight="bold">
            Sarah Elizabeth
          </Typography>
          <Typography variant="body2" component="h3" color="text.secondary">
            Amazon Deals Expert
          </Typography>

          {/* Link to Full Bio */}
          <MUILink
            component={Link}
            to="/author/sarah"
            onClick={() => window.scrollTo(0, 0)}
            sx={{
              color,
              display: 'inline-block',
              marginTop: 1,
              fontSize: '0.875rem',
              fontWeight: 'bold',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Read more about Sarah →
          </MUILink>
          <MUILink
            href={config.TIKTOK_LINK}
            target="_blank"
            sx={{
              color,
              display: 'block',
              marginTop: 1,
              fontSize: '0.875rem',
              fontWeight: 'bold',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Follow on TikTok →
          </MUILink>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogPostAuthorBio;
